import React, { useEffect, useMemo, useRef, useState } from "react";
import Sections from "components/sections/sections";
import Seo from "components/Seo";
import { getGlobalData, getPageData } from "utils/api";
import { Mixpanel } from "utils/mixpanel";
import { filterHectareBlog } from "utils/utils";
import { getFilterData } from "utils/api";
import ResultComponent from "components/pageComponents/resources/resultComponent/careerResultComponent";
import { getCareers } from "utils/api/career";
import Container from "components/sections/container";
import SelectField from "components/form/selectField";


const CareerPage = ({
  blogs,
  categories,
  metadata,
  global,
  pageData,
  sections,
}) => {
  const [stateCategories, setCategories] = useState(categories);

  const filCategories = useMemo(
    () =>
      (stateCategories?.data &&
        stateCategories.data.map((element) => {
          return { [element.attributes.slug]: element.attributes.title };
        })) ||
      [],
    [stateCategories]
  );

  const filters = {
    Category: filCategories || [],
    Year: [{ 2022: "2022" }, { 2023: "2023" }, { 2024: "2024" },{ 2025: "2025" }],
   // Country: [{ Nigeria: "Nigeria" }],
  };
  const [data, setData] = useState(blogs);

  const filter = useRef({});
  const onChange = (e) => {
    filter.current[e.target.name] = e.target.value;

    getCareers(0, 6, filterHectareBlog(filter)).then((data) => {
      setData(data ?? []);
    });
  };

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    const trackPageHit = () => {
      Mixpanel.track(pageData?.title || "hectare homepage");
    };
    trackPageHit();
    const update = async () => {
      const blogs = await getCareers(0, 6);
      const allCategories = await getFilterData("/career-categories");

      setCategories(allCategories);
      setData(blogs);
    };
    update();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //   const BHeader = useMemo(() => {
  //     const featuredBlogD = featuredBlog?.data[0];
  //     const blogAttributes = featuredBlogD?.attributes?.Blogheader;
  //     const categoryAttributes =
  //       featuredBlogD?.attributes?.category?.data?.attributes;
  //     return (
  //       (featuredBlogD && showHeader && (
  //         <BlogHeader
  //           title={blogAttributes?.title}
  //           description={blogAttributes?.description}
  //           date={blogAttributes?.date}
  //           category={categoryAttributes?.title}
  //           imgSrc={blogAttributes?.image?.data?.attributes?.url ?? RESOURCES_1}
  //           link={`/resources/hectare/${featuredBlogD?.attributes?.slug}`}
  //         />
  //       )) || <></>
  //     );
  //   }, [featuredBlog?.data, showHeader]);
  // Merge default site SEO settings with page specific SEO settings

  if (!metadata?.shareImage?.data) {
    delete metadata.shareImage;
  }
  const metadataWithDefaults = {
    ...global.attributes.metadata,
    ...metadata,
  };

  return (
    <>
      <Seo metadata={metadataWithDefaults} />
      <Container>
        <Sections sections={JSON.parse(sections)} />
      </Container>
      <Container additionalClass="bg-black py-4">
        <div className="md:justify-start grid gap-8 w-full grid-cols-[repeat(auto-fill,minmax(130px,1fr))] md:auto-cols-min md:grid-cols-[repeat(4,min-content)] h-full">
          {filters &&
            Object.keys(filters).map((key, index) => {
              return (
                <SelectField
                  key={"career-field-filter-" + index}
                  name={key}
                  onChange={onChange}
                  options={filters[key]}
                  placeholder={key}
                />
              );
            })}
        </div>
      </Container>
      <ResultComponent ref={filter} results={data?.data} meta={data?.meta} />
    </>
  );
};

export default CareerPage;

export async function getServerSideProps(context) {
  const globalLocale = await getGlobalData(context.locale);
  const pageData = await getPageData({ full_slug: "/about-us/career-page" });
  const blogs = await getCareers(0, 6);
  const allCategories = await getFilterData("/career-categories");

  const { metadata, contentSections, ...pageExtraData } = pageData.attributes;
  if (blogs && !pageData) {
    return {
      props: {
        blogs: blogs,
        global: globalLocale,
        sections: JSON.stringify(contentSections),
        categories: allCategories,
      },
    };
  }

  if (!pageData && !blogs) {
    return { props: {} };
  }
  return {
    props: {
      blogs: blogs ?? {},
      global: globalLocale,
      categories: allCategories ?? {},
      sections: JSON.stringify(contentSections),
      metadata,
      pageData: pageExtraData ?? {},
    },
  };
}
